import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { fetchAllNews } from "../contexts/fetchData";



// const gxStyle = {
//     overflow: hidden;
//     text-overflow: Ellipsis;
// }
export const ImgCol = props => {
    const { src } = props
    return (
        <Col lg='3' md='4' sm='5' xs='12' className="col text-center">
            <img alt="" src={src} style={{ height: '150px', width: '90%', objectFit: 'contain'}} />
        </Col>
    )
}

export const DetailCol = ({ title, des, link, date, pinned, hidden }) => {

    const [isFullMode, setFullMode] = useState(false);
    const [desTxt, setDesTxt] = useState("")
    const maxChar = 300;

    // useEffect(() => {
    //     setDesTxt(des.length < maxChar ? des : des.slice(0, maxChar));
    // }, [des])

    useEffect(() => {
        if (isFullMode) {
            setDesTxt(des)
        }
        else {
            //setDesTxt(des.slice(0, maxChar))
            setDesTxt(des.length < maxChar ? des : des.slice(0, maxChar));
        }
    }, [des, isFullMode])

    const displayDate = (date) => {
        const d = date.split('-')
        return d[2] + '-' + d[1] + '-' + d[0]
    }

    return (
        <Col hidden={hidden}>
            <h6 style={{paddingTop: '10px'}}>
                <img alt='' src={`${process.env.PUBLIC_URL}/icons/pinned.png`} style={{width: '32px'}} hidden={!pinned} />{title}
            </h6>
            <div style={{textAlign: 'justify', fontSize: '14.5px'}}>
                {desTxt}{!isFullMode && des.length > maxChar  ? "..." : ""}
                <br />
                <Button hidden={des.length < maxChar} variant="link" onClick={() => setFullMode(!isFullMode)}>{isFullMode ? "Show Less" : "Show More"}</Button> 

            </div>
            <Row>
                <Col>
                    <span className="date-muted">{displayDate(date)}</span>
                </Col>
                <Col xs='auto'>
                    <span className="text-end" hidden={!link}><a href={link} target="_blank" rel="noopener noreferrer">{"[Link]"}</a> </span>
                </Col>
            </Row>
            <hr className="d-block d-md-none" />
        </Col>
    )
}


// export const OneNews = props => {
//     const { title, des, src, link, date, hidden, pinned } = props

//     const [isFullMode, setFullMode] = useState(false);

//     const [desTxt, setDesTxt] = useState("")

//     const maxChar = 200;

//     useEffect(() => {
//         setDesTxt(des.length < maxChar ? des : des.slice(0, maxChar));
//     }, [des])

//     useEffect(() => {
//         if (isFullMode) {
//             setDesTxt(des)
//         }
//         else {
//             setDesTxt(des.slice(0, maxChar))
//         }
//     }, [des, isFullMode])

//     return (
//         <Row className="row mb-4" hidden={hidden}>
//             <ImgCol src={src} />
//             <Col>
//                 <h6 style={{paddingTop: '10px'}}>
//                     <img alt='' src={`${process.env.PUBLIC_URL}/icons/pinned.png`} style={{width: '32px'}} hidden={!pinned} />{title}
//                 </h6>
//                 <div style={{textAlign: 'justify'}}>
//                     {desTxt}{!isFullMode && des.length > maxChar  ? "..." : ""}
//                     <br />
//                     <Button hidden={des.length < maxChar} variant="link" onClick={() => setFullMode(!isFullMode)}>{isFullMode ? "Show Less" : "Show More"}</Button> 

//                 </div>
//                 <DateCol link={link} date={date} />
//             </Col>
//         </Row>
//     )
// }

//style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}

const NewsComponent = () => {
    const [data, setData] = useState([])
    const [imgs, setImgs] = useState({})

    useEffect(() => {
        return () => {
            setData([])
            setImgs({})
        }
    }, [])

    useEffect(() => {
        const fetchNews = async () => await fetchAllNews(setData, setImgs);
        fetchNews();
    }, [])

    return (
        <Row>
            <Col 
                xl={{offset: 2, span: 8}}
                lg={{offset: 1, span: 10}}
                md={{offset: 0, span: 12}}
                className="main-comp"
            >
                <h4>NEWS</h4>
                <hr />
                {/* {data?.map((d, index) => (
                    <OneNews key={index} title={d.title} des={d.description} src={imgs[d?.id]} link={d.link} date={d.date} hidden={d.hidden} pinned={d.pinned}/>
                ))} */}
                {data?.map((d, index) => (
                    <Row className="row mb-4" key={index} hidden={d.hidden}>
                        <ImgCol src={imgs[d?.id]} />
                        <DetailCol title={d.title} des={d.description} link={d.link} date={d.date} pinned={d.pinned} />
                        
                    </Row>
                ))}
            </Col>
            
        </Row>
    )


}

export default NewsComponent;